export const FEATURE_FLAGS = {
  wrapped: process.env.VITE_FEATURE_WRAPPED === "true",
  savingPockets: process.env.VITE_FEATURE_SAVING_POCKETS === "true",
  domainChat: process.env.VITE_FEATURE_DOMAIN_CHAT === "true",
  transactionCsvImport: process.env.VITE_FEATURE_TRANSACTION_CSV_IMPORT === "true",
} as const;
